import type { LightingAdvisorTileId } from '~/types/lightingAdvisor';

/** Magento filter keys set by the lighting advisor per PLP tile. */
export const LIGHTING_ADVISOR_MAGENTO_FILTER_KEYS_BY_TILE: Record<
  LightingAdvisorTileId,
  readonly string[]
> = {
  tile1: ['light_category_parent', 'light_category'],
  tile2: [
    'maximum_object_size_length_x_width',
    'recommended_max_wd',
    'recommended_min_wd'
  ],
  tile3: ['light_color', 'peak_wavelength_typical']
};

export const LIGHTING_ADVISOR_QUESTION_IDS_BY_TILE: Record<
  LightingAdvisorTileId,
  readonly string[]
> = {
  tile1: ['a2s1q1', 'a2s1q2', 'a2s1q3'],
  tile2: ['a2s2q1', 'a2s2q2'],
  tile3: ['a2s3q1', 'a2s3q2', 'a2s3q3']
};

export const LIGHTING_ADVISOR_WORKING_DISTANCE_RANGE_MAX = '999999';

export const ALL_LIGHT_TYPE_VALUES = [
  'back_light',
  'bar_light',
  'coaxial_light',
  'dark_field_light',
  'dome_light',
  'flat_dome_light',
  'ring_light',
  'spot_light'
] as const;
